const HL = ["ring-2", "ring-amber-400", "ring-offset-4", "rounded-md", "bg-amber-50"];

const findTarget = (tab, anchors) => {
  const root = document.querySelector(tab === "synthese" ? "[data-testid=dossier-synthese]" : `[data-testid=tab-content-${tab}]`)
    || (tab === "synthese" ? document.querySelector("[data-testid=synthese-custom-fields]") : null);
  if (!root) return null;
  for (const a of anchors || []) {
    const el = root.querySelector(`[data-testid="field-${a}"]`) || document.querySelector(`[data-testid=synthese-custom-fields] [data-testid="field-${a}"]`);
    if (el) return el;
  }
  return null;
};

export function focusField(tab, anchors) {
  window.dispatchEvent(new CustomEvent("norea:open-tab", { detail: tab }));
  let tries = 0;
  const tick = () => {
    const el = findTarget(tab, anchors);
    if (!el) { if (++tries < 40) setTimeout(tick, 100); return; }
    el.scrollIntoView({ behavior: "smooth", block: "center" });
    el.classList.add(...HL);
    const input = [...el.querySelectorAll("input, select, textarea")].find((i) => i.placeholder !== "Statut libre" && !i.className.includes("text-[11px]"));
    const edit = el.querySelector("[data-testid$=-edit-btn]");
    setTimeout(() => (input ? input.focus({ preventScroll: true }) : edit?.click()), 400);
    setTimeout(() => el.classList.remove(...HL), 3000);
  };
  setTimeout(tick, 150);
}
